import { base64ToUint8Array } from './base64ToUint8Array';

export const createUrlFromBase64 = (str, mimeType) => {
  const uint = base64ToUint8Array(str);
  const value = URL.createObjectURL(
    new Blob([uint], mimeType ? { type: mimeType } : undefined)
  );

  return { value, removeUrl: () => URL.revokeObjectURL(value) };
};
